import { render, staticRenderFns } from "./TourAllocation.vue?vue&type=template&id=7487800b&scoped=true&"
import script from "./TourAllocation.vue?vue&type=script&lang=js&"
export * from "./TourAllocation.vue?vue&type=script&lang=js&"
import style0 from "./TourAllocation.vue?vue&type=style&index=0&id=7487800b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7487800b",
  null
  
)

export default component.exports